import Crud from '../components/RequestsHistory/Crud'

let routes = {
    path: '/requests_history',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/requests_history',
            name: 'Histórico de Consultas',
            component: Crud
        },
    ]
};

export default routes


// WEBPACK FOOTER //
// ./src/router/rqHistory.js